import { useMutation } from '@tanstack/react-query';
import { getDraftContentStatus } from '../../services';

export function useGetDraftContentStatus() {
  return useMutation(getDraftContentStatus, { onSuccess: (data) => data });
}
